module.exports = __webpack_public_path__ + "img/图1-11尺寸线终端的箭头.07192130.png";